// 변경공사 저장소 두 벌(인메모리·Supabase)과 `0026`·`0055` 가 같이 쓰는 문구 — SQL 에 있는 것은 한 글자도 다르면 안 된다(테스트가 본다).

import { CHANGE_ORDER_STATUS_LABEL, type ChangeOrderStatus } from "./types";
import { CONTRACT_LINK_DEAD_MESSAGE, CONTRACT_SIGN_RATE_MESSAGE } from "../contract/messages";

export const CHANGE_ORDER_NOT_FOUND_MESSAGE = "변경공사를 찾을 수 없습니다";
// 고객 링크 합의가 승인 대기가 아닌 건에 닿았을 때 — 작성 중인 건은 고객에게 없는 것으로 둔다.
export const changeOrderCustomerAcceptBlockedMessage = (status: ChangeOrderStatus): string =>
  status === "DRAFT"
    ? CHANGE_ORDER_NOT_FOUND_MESSAGE
    : `이미 처리된 변경공사입니다 (「${CHANGE_ORDER_STATUS_LABEL[status]}」)`;
export const CHANGE_ORDER_CONTRACT_NOT_FOUND_MESSAGE = "계약을 찾을 수 없습니다";
export const CHANGE_ORDER_CONTRACT_NOT_SIGNED_MESSAGE = "체결된 계약에만 변경공사를 할 수 있습니다";
export const CHANGE_ORDER_PROJECT_INACTIVE_MESSAGE =
  "착공 전·시공 중·유지보수 중인 현장에서만 변경공사를 할 수 있습니다";
// 유지보수 현장은 옮길 준공 예정일이 없다 — 앱과 `0067` 보내기·승인이 같이 막는다(SQL 은 hint 를 붙인다).
export const CHANGE_ORDER_WARRANTY_EXTEND_MESSAGE =
  "유지보수 중인 현장은 공기를 늘리거나 줄일 수 없습니다 — 공기 증감을 비우고 다시 저장해 주세요";
// 이미 보낸 건은 고칠 수 없어 담당자 화면에는 파기 후 다시 쓰라고 안내한다.
export const CHANGE_ORDER_WARRANTY_EXTEND_SENT_NOTICE =
  "유지보수 중인 현장이라 공기 증감이 실린 이 변경공사는 승인할 수 없습니다 — 파기한 뒤 공기 증감 없이 다시 작성하세요";
export const CHANGE_ORDER_NOT_DRAFT_MESSAGE = "작성 중인 변경공사만 고칠 수 있습니다";
export const CHANGE_ORDER_PROJECT_CLOSED_MESSAGE = "완료된 현장의 변경공사는 만들거나 고칠 수 없습니다";
export const CHANGE_ORDER_REV_MESSAGE =
  "그 사이 변경공사가 바뀌었습니다 — 새로고침한 뒤 다시 저장해 주세요";
export const CHANGE_ORDER_BASE_STALE_MESSAGE =
  "다른 변경공사가 먼저 반영됐습니다 — 새로고침한 뒤 다시 확인해 주세요";
export const CHANGE_ORDER_PAYMENTS_STALE_MESSAGE =
  "지급 기록이 바뀌었습니다 — 새로고침한 뒤 다시 보내 주세요";
export const CHANGE_ORDER_ALREADY_SENT_MESSAGE =
  "이 계약에 이미 보낸 변경공사가 있습니다 — 먼저 처리해 주세요";
export const CHANGE_ORDER_NO_LINK_MESSAGE =
  "고객 링크가 없는 계약입니다 — 종이로 받은 승인만 기록할 수 있습니다";
export const CHANGE_ORDER_EMPTY_MESSAGE = "변경 항목이나 공기 연장을 하나 이상 적어 주세요";
export const CHANGE_ORDER_HASH_MISMATCH_MESSAGE =
  "변경 문서가 해시와 맞지 않습니다 — 새로고침한 뒤 다시 확인해 주세요";
export const CHANGE_ORDER_DECIDER_BLANK_MESSAGE = "승인자 이름이 비어 있습니다";
export const CHANGE_ORDER_PAYMENT_SUM_MESSAGE = "지급회차 금액이 변경 후 금액과 맞지 않습니다";
export const CHANGE_ORDER_PAYMENT_NOT_FOUND_MESSAGE = "지급회차를 찾을 수 없습니다";
export const CHANGE_ORDER_PAID_NOT_SIGNED_MESSAGE =
  "체결된 계약의 지급회차만 지급 기록을 남길 수 있습니다";
export const CHANGE_ORDER_LOG_OTHER_PROJECT_MESSAGE = "같은 현장의 일지만 연결할 수 있습니다";
export const CHANGE_ORDER_AUTHOR_NOT_FOUND_MESSAGE = "작성자를 찾을 수 없습니다";
export const CHANGE_ORDER_LINK_DEAD_MESSAGE = CONTRACT_LINK_DEAD_MESSAGE;
export const CHANGE_ORDER_LINES_MISMATCH_MESSAGE =
  "변경 문서가 항목과 맞지 않습니다 — 새로고침한 뒤 다시 확인해 주세요";
export const CHANGE_ORDER_AMOUNTS_MISMATCH_MESSAGE =
  "변경 문서가 금액·회차와 맞지 않습니다 — 새로고침한 뒤 다시 확인해 주세요";
// `0057` 보낸 건의 굳은 문서가 싣는 회차와 어긋났다 — 새로고침으로는 안 풀리고 회수 후 다시 써야 한다(정상 운영에선 나지 않는다).
export const CHANGE_ORDER_SENT_DOC_MISMATCH_MESSAGE =
  "변경 문서가 금액·회차와 맞지 않습니다 — 회수한 뒤 다시 작성해 주세요";
export const CHANGE_ORDER_ACTIVITY_MISSING_MESSAGE = "변경 기록이 빠졌습니다";
// `0055` 지급 기록이 hint 와 함께 올리는 문구 — 화면에는 paidWithSentConfirmMessage 가 대신 나간다.
export const CHANGE_ORDER_SENT_CONFIRM_SQL_MESSAGE =
  "보낸 변경공사가 승인할 수 없게 됩니다 — 한 번 더 누르면 기록합니다";

// 보낸 뒤 지급 기록이 바뀌어 영영 승인할 수 없게 된 건 — 담당자 화면 안내와 고객 화면 안내.
export const CHANGE_ORDER_SENT_STALE_NOTICE =
  "지급회차가 바뀌어 이 변경공사는 승인할 수 없습니다 — 회수 후 다시 보내세요";
export const CHANGE_ORDER_RECREATE_NOT_SENT_MESSAGE = "보낸 변경공사만 회수하고 새로 만들 수 있습니다";
export const CHANGE_ORDER_RECREATE_NOT_STALE_MESSAGE =
  "지급회차가 그대로라 아직 승인할 수 있습니다 — 회수하고 새로 만들 필요가 없습니다";
export const CHANGE_ORDER_RECREATED_REASON = "지급회차가 바뀌어 회수하고 새로 만듦";
// 보낸 변경공사가 있는 계약의 지급 표시 — 한 번 더 누르면 기록한다(ConfirmRequiredError) · 차수를 못 읽었으면(빈 목록) 차수 없이 쓴다.
export const paidWithSentConfirmMessage = (seqs: readonly number[]): string =>
  seqs.length === 0
    ? "보낸 변경공사가 있습니다. 지급을 기록하면 승인할 수 없게 됩니다 — 회수 후 다시 보내야 합니다. 그래도 기록할까요?"
    : `보낸 변경공사 ${seqs.map((n) => `${n}차`).join("·")}가 승인할 수 없게 됩니다 — 회수 후 다시 보내야 합니다. 그래도 기록할까요?`;
export const CHANGE_ORDER_RESEND_PENDING_MESSAGE = "내용이 바뀌어 담당자가 다시 보낼 예정입니다";
export const CHANGE_ORDER_CUSTOMER_RATE_MESSAGE = CONTRACT_SIGN_RATE_MESSAGE;

// 고객 링크(/c/[token]) 변경공사 섹션 문구 — 「전자서명·효력 보장」 은 쓰지 않는다.
export const CHANGE_ORDER_CONSENT_LABEL = "위 변경 내용(항목·금액·지급회차)을 확인했고 이에 합의합니다";
export const CHANGE_ORDER_RECORD_NOTICE =
  "합의하면 입력한 이름·시각·접속 정보(IP·브라우저)·문서 해시가 전자적 합의 기록으로 남습니다.";
export const CHANGE_ORDER_DECIDE_FAILED_MESSAGE = "처리하지 못했습니다. 잠시 후 다시 시도해 주세요";

// ★3·★4 대조 실패에 SQL 이 붙이는 hint — rpcFail 이 이 값으로 ChangeOrderStaleError 를 만든다.
export const CHANGE_ORDER_STALE_HINT = "change_order_stale";
// 보낸 변경공사가 있는 계약의 지급 기록을 SQL 이 막을 때 붙이는 hint — detail 은 차수 목록("1,2").
export const CHANGE_ORDER_SENT_CONFIRM_HINT = "change_order_sent_confirm";
// `0067` 유지보수 현장에 공기 증감이 실린 보내기·승인을 SQL 이 막을 때 붙이는 hint — WarrantyExtendError 로 바꾼다.
export const CHANGE_ORDER_WARRANTY_EXTEND_HINT = "change_order_warranty_extend";
// `0073` 승인 때 감액이 원 견적 잔량을 넘으면 붙이는 hint — detail 은 {id,label,qty,amount,unit} JSON, DeductOverRemainingError 로 바꾼다.
export const CHANGE_ORDER_DEDUCT_OVER_HINT = "change_order_deduct_over";
// `0073` 이 올리는 문구 — 화면에는 detail 로 지은 DeductOverRemainingError 문구가 대신 나간다.
export const CHANGE_ORDER_DEDUCT_OVER_SQL_MESSAGE = "감액이 원 견적에 남은 양을 넘습니다 — 새로고침한 뒤 다시 확인해 주세요";

// `0026`·`0055` 가 raise 하는 문구 — 테스트가 SQL 본문에 그대로 있는지 센다.
export const CHANGE_ORDER_SQL_MESSAGES = [
  CHANGE_ORDER_NOT_FOUND_MESSAGE,
  CHANGE_ORDER_CONTRACT_NOT_FOUND_MESSAGE,
  CHANGE_ORDER_CONTRACT_NOT_SIGNED_MESSAGE,
  CHANGE_ORDER_PROJECT_INACTIVE_MESSAGE,
  CHANGE_ORDER_NOT_DRAFT_MESSAGE,
  CHANGE_ORDER_REV_MESSAGE,
  CHANGE_ORDER_BASE_STALE_MESSAGE,
  CHANGE_ORDER_PAYMENTS_STALE_MESSAGE,
  CHANGE_ORDER_ALREADY_SENT_MESSAGE,
  CHANGE_ORDER_NO_LINK_MESSAGE,
  CHANGE_ORDER_EMPTY_MESSAGE,
  CHANGE_ORDER_HASH_MISMATCH_MESSAGE,
  CHANGE_ORDER_DECIDER_BLANK_MESSAGE,
  CHANGE_ORDER_PAYMENT_SUM_MESSAGE,
  CHANGE_ORDER_PAYMENT_NOT_FOUND_MESSAGE,
  CHANGE_ORDER_PAID_NOT_SIGNED_MESSAGE,
  CHANGE_ORDER_LOG_OTHER_PROJECT_MESSAGE,
  CHANGE_ORDER_AUTHOR_NOT_FOUND_MESSAGE,
  CHANGE_ORDER_LINK_DEAD_MESSAGE,
  CHANGE_ORDER_LINES_MISMATCH_MESSAGE,
  CHANGE_ORDER_AMOUNTS_MISMATCH_MESSAGE,
  CHANGE_ORDER_ACTIVITY_MISSING_MESSAGE,
  CHANGE_ORDER_RECREATE_NOT_SENT_MESSAGE,
  CHANGE_ORDER_RECREATE_NOT_STALE_MESSAGE,
  CHANGE_ORDER_SENT_CONFIRM_SQL_MESSAGE,
  CHANGE_ORDER_WARRANTY_EXTEND_MESSAGE,
] as const;

// 편집 중 다시 읽은 값이 바뀌어 정산 미리보기를 새로 계산했을 때 — 바뀐 까닭(지급 기록·다른 변경공사 반영)대로 문구를 고른다.
export const CHANGE_ORDER_PAYMENTS_RELOADED_NOTICE = "지급 기록이 바뀌어 정산 회차 미리보기를 새로 계산했습니다";
export const CHANGE_ORDER_TOTAL_RELOADED_NOTICE = "다른 변경공사가 반영돼 지금 계약금액과 정산 회차 미리보기를 새로 계산했습니다";
export const CHANGE_ORDER_BOTH_RELOADED_NOTICE =
  "지급 기록이 바뀌고 다른 변경공사도 반영돼 지금 계약금액과 정산 회차 미리보기를 새로 계산했습니다";
export const reloadedNoticeOf = (paymentsChanged: boolean, totalChanged: boolean): string | null =>
  paymentsChanged && totalChanged
    ? CHANGE_ORDER_BOTH_RELOADED_NOTICE
    : paymentsChanged
      ? CHANGE_ORDER_PAYMENTS_RELOADED_NOTICE
      : totalChanged
        ? CHANGE_ORDER_TOTAL_RELOADED_NOTICE
        : null;
// 다시 읽어 보니 rev 가 올랐다(다른 곳의 저장·보내기·취소·무효) — 고친 게 없으면 지금 저장본으로 다시 불러오고, 있으면 미리보기가 옛 값이라고 띄운다.
export const CHANGE_ORDER_REV_RELOADED_NOTICE =
  "다른 곳에서 이 변경공사가 저장되거나 상태가 바뀌어 지금 저장본으로 변경공사와 미리보기를 다시 불러왔습니다";
export const CHANGE_ORDER_REV_STALE_NOTICE =
  "다른 곳에서 이 변경공사가 저장되거나 상태가 바뀌어 「변경 전 → 후」 미리보기가 옛 값입니다 — 새로고침하면 지금 저장본과 미리보기를 불러옵니다(지금 고친 내용은 사라집니다)";
// rev 로 다시 불러올 때 지급 기록·계약금액 변화도 있으면 그 까닭을 덧붙인다.
export const revReloadedNoticeOf = (reloaded: string | null): string =>
  reloaded ? `${CHANGE_ORDER_REV_RELOADED_NOTICE} — ${reloaded}` : CHANGE_ORDER_REV_RELOADED_NOTICE;
// 현재 내역서 — 목록엔 승인으로 있는데 항목을 못 읽었다(그 사이 바뀜·읽기 실패).
export const statementDetailMissingMessage = (seq: number): string =>
  `변경공사 ${seq}차를 읽지 못해 현재 내역서를 보일 수 없습니다 — 잠시 뒤 새로고침해 주세요`;
// 원 견적 줄 연결 — 이 계약 견적의 맨 끝 항목만 고를 수 있다(`0072` 가드와 같은 규칙).
export const CHANGE_ORDER_SOURCE_SCOPE_MESSAGE = "이 계약의 견적에 있는 줄만 연결할 수 있습니다 — 견적 줄을 다시 골라 주세요";
